'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectLayout = exports.ProjectMenuBar = exports.ProjectLayoutViewStore = undefined;

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _desc, _value, _class, _descriptor, _class2, _temp, _class3, _desc2, _value2, _class4, _descriptor2, _class6, _class7, _temp3;

// import DevTools,  { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from 'mobx-react-devtools';
// window.setLogEnabled = setLogEnabled;
// window.setUpdatesEnabled = setUpdatesEnabled;
// window.setGraphEnabled = setGraphEnabled;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _autoclassDecorator = require('autoclass-decorator');

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseViewstore = require('base-viewstore');

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseComponent = require('base-component');

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _mixwith = require('mixwith');

var _layoutComponent = require('layout-component');

var _simboxEditable = require('simbox-editable');

var _uiBlockingModal = require('ui-blocking-modal');

var _uiBlockingModal2 = _interopRequireDefault(_uiBlockingModal);

var _confirmationModal = require('confirmation-modal');

var _confirmationModal2 = _interopRequireDefault(_confirmationModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var editorViewStore = new _simboxEditable.ViewStore({});

var ProjectLayoutViewStore = exports.ProjectLayoutViewStore = (_dec = _mobx.observable.ref, (_class = (_temp = _class2 = function (_mix$with) {
  (0, _inherits3.default)(ProjectLayoutViewStore, _mix$with);

  // do not need to track these
  function ProjectLayoutViewStore(props) {
    (0, _classCallCheck3.default)(this, ProjectLayoutViewStore);
    var application = props.application;

    if (!application) throw new Error("application is missing");

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProjectLayoutViewStore.__proto__ || (0, _getPrototypeOf2.default)(ProjectLayoutViewStore)).apply(this, arguments));

    _initDefineProp(_this, 'application', _descriptor, _this);

    _this.application = application;
    _this.props = (0, _assign2.default)({}, props, { editorViewStore: editorViewStore }); //cheating

    _this.dispose = (0, _mobx.reaction)(function () {
      return (0, _keys2.default)(_this.viewMap).join("");
    }, function () {
      var views = (0, _keys2.default)(_this.viewMap);
      if (views.length === 1) {
        // will force you to authStrategy destination
        if (_this._currentView !== views[0].id && _this._currentView !== views[0]) {
          _this.selectView(views[0]);
        }
      }
    }, { fireImmediately: true });
    return _this;
  }

  (0, _createClass3.default)(ProjectLayoutViewStore, [{
    key: 'viewMap',
    get: function get() {
      if (!this.application) return {};
      return this.application.viewMap;
    }
  }, {
    key: 'showMenuBar',
    get: function get() {
      //overrides ViewControllerMixin showMenuBar
      return this.viewMap && (0, _keys2.default)(this.viewMap).length > 1;
    }
  }, {
    key: 'inEditingMode',
    get: function get() {
      var _props = this.props,
          application = _props.application,
          _props$application = _props.application,
          route = _props$application.route,
          domainStore = _props$application.dataModel.domainStore;

      //return (window.trcAppSettings && window.trcAppSettings.environment === "dev") 

      return application.isSettingUp // initializing environment
      || !!route && route.authStrategy && route.authStrategy.done && domainStore.context.user.roleID !== 2 //not a participant
      ;
    }
  }]);
  return ProjectLayoutViewStore;
}((0, _mixwith.mix)(_baseViewstore2.default).with(_layoutComponent.ViewControllerMixin)), _class2.trackBreadcrumbs = false, _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'application', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'viewMap', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'viewMap'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'showMenuBar', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'showMenuBar'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'inEditingMode', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'inEditingMode'), _class.prototype)), _class));

var ProjectMenuBar = exports.ProjectMenuBar = (0, _mobxReact.observer)(_class3 = (_class4 = function (_BaseComponent) {
  (0, _inherits3.default)(ProjectMenuBar, _BaseComponent);

  function ProjectMenuBar() {
    var _ref;

    var _temp2, _this2, _ret;

    (0, _classCallCheck3.default)(this, ProjectMenuBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = ProjectMenuBar.__proto__ || (0, _getPrototypeOf2.default)(ProjectMenuBar)).call.apply(_ref, [this].concat(args))), _this2), _initDefineProp(_this2, 'menuOpen', _descriptor2, _this2), _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(ProjectMenuBar, [{
    key: 'toggleMenu',
    value: function toggleMenu(event) {
      this.menuOpen = !this.menuOpen;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          viewMap = _props2.viewMap,
          clickItem = _props2.clickItem,
          currentViewId = _props2.currentViewId,
          signOut = _props2.signOut,
          userInfo = _props2.userInfo;

      var displayItems = (0, _values2.default)(viewMap).filter(function (v) {
        return v.show || v.menu && v.menu.show;
      });
      return _react2.default.createElement(
        'div',
        { className: this.menuOpen === true ? 'menu' : 'menu closed' },
        _react2.default.createElement('div', { className: this.menuOpen === true ? 'menu-toggle hidden' : 'menu-toggle', title: 'Open Menu', onClick: function onClick() {
            return _this3.toggleMenu();
          } }),
        _react2.default.createElement(
          'header',
          { className: 'header' },
          _react2.default.createElement('img', { src: 'assets/images/trc-logo-inverted.svg' }),
          _react2.default.createElement('div', { className: 'hide-menu', onClick: function onClick() {
              return _this3.toggleMenu();
            }, title: 'Close Menu' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'session-details' },
          !!userInfo && _react2.default.createElement(
            'div',
            { className: 'session' },
            _react2.default.createElement(
              'span',
              { className: 'label' },
              'User:'
            ),
            _react2.default.createElement(
              'span',
              { className: 'user' },
              userInfo.firstName && userInfo.lastName ? userInfo.lastName + ", " + userInfo.firstName : userInfo.loginName
            )
          ),
          !!signOut && _react2.default.createElement(
            'div',
            { className: 'actions' },
            _react2.default.createElement(
              'div',
              { className: 'action', onClick: function onClick(e) {
                  return signOut();
                } },
              'Logout'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'menu-items' },
          displayItems.map(function (view, index) {
            var iconClass = view.icon || view.contentModel && view.contentModel.icon || "";
            var menu = (0, _assign2.default)({ clickItem: clickItem }, view, view.menu);
            return _react2.default.createElement(
              'span',
              { key: "" + menu.id + index, className: menu.id === currentViewId ? "active" : "inactive" },
              _react2.default.createElement(
                'button',
                { className: "menu-item " + iconClass, onClick: function onClick(e) {
                    return !!menu.clickItem && menu.clickItem(view, viewMap);
                  }, disabled: menu.hasOwnProperty('enabled') ? !menu.enabled : false },
                menu.displayName,
                menu.displayTitle || menu.displayName || menu.id
              )
            );
          })
        )
      );
    }
  }]);
  return ProjectMenuBar;
}(_baseComponent2.default), (_descriptor2 = _applyDecoratedDescriptor(_class4.prototype, 'menuOpen', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _applyDecoratedDescriptor(_class4.prototype, 'toggleMenu', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class4.prototype, 'toggleMenu'), _class4.prototype)), _class4)) || _class3;

var ProjectLayout = exports.ProjectLayout = (0, _mobxReact.observer)(_class6 = (0, _autoclassDecorator2.default)(_class6 = (_temp3 = _class7 = function (_BaseComponent2) {
  (0, _inherits3.default)(ProjectLayout, _BaseComponent2);

  function ProjectLayout() {
    (0, _classCallCheck3.default)(this, ProjectLayout);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectLayout.__proto__ || (0, _getPrototypeOf2.default)(ProjectLayout)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectLayout, [{
    key: 'render',
    value: function render() {
      var _viewStore = this.viewStore,
          SelectedView = _viewStore.SelectedView,
          currentView = _viewStore.currentView,
          selectView = _viewStore.selectView,
          showMenuBar = _viewStore.showMenuBar,
          inEditingMode = _viewStore.inEditingMode,
          _props3 = this.props,
          application = _props3.application,
          _props3$application = _props3.application,
          dataModel = _props3$application.dataModel,
          domainStore = _props3$application.dataModel.domainStore,
          viewMap = _props3$application.viewMap,
          route = _props3$application.route,
          blockingModalState = _props3$application.blockingModalState,
          modalViewStore = _props3$application.modalViewStore;


      var viewKey = currentView && (currentView.type || currentView.contentModel && currentView.contentModel.type || currentView.id);

      // editorViewStore is "provided" so that is available to be injected into components via the "editable" decorator
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_uiBlockingModal2.default, { devMode: false, appState: blockingModalState }),
        _react2.default.createElement(_confirmationModal2.default, { viewStore: modalViewStore }),
        typeof DevTools !== "undefined" && _react2.default.createElement(DevTools, null),
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement(
            _mobxReact.Provider,
            { editorViewStore: inEditingMode && editorViewStore, dataModel: dataModel, application: application, modalViewStore: modalViewStore },
            _react2.default.createElement(
              'div',
              { className: 'columns' },
              showMenuBar && _react2.default.createElement(ProjectMenuBar, { viewMap: viewMap, clickItem: selectView, currentViewId: currentView && currentView.id, signOut: dataModel.domainStore.signOut, userInfo: dataModel.domainStore.context.user }),
              SelectedView && _react2.default.createElement(
                'div',
                { className: "middle " + viewKey },
                _react2.default.createElement(SelectedView, null)
              ),
              SelectedView && _react2.default.createElement(_simboxEditable.Component, { viewStore: editorViewStore })
            )
          )
        ),
        _react2.default.createElement('footer', { className: 'footer' })
      );
    }
  }]);
  return ProjectLayout;
}(_baseComponent2.default), _class7.ViewStore = ProjectLayoutViewStore, _temp3)) || _class6) || _class6;

var _default = ProjectLayout;
exports.default = _default;

//          <div className="trc-logo"></div>

;

var _temp4 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(editorViewStore, 'editorViewStore', 'src/core_modules/authoring-application/project-layout.js');

  __REACT_HOT_LOADER__.register(ProjectLayoutViewStore, 'ProjectLayoutViewStore', 'src/core_modules/authoring-application/project-layout.js');

  __REACT_HOT_LOADER__.register(ProjectMenuBar, 'ProjectMenuBar', 'src/core_modules/authoring-application/project-layout.js');

  __REACT_HOT_LOADER__.register(ProjectLayout, 'ProjectLayout', 'src/core_modules/authoring-application/project-layout.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/core_modules/authoring-application/project-layout.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/authoring-application/project-layout.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/authoring-application/project-layout.js
// module chunks = 0